import "core-js/modules/es6.promise";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es7.object.entries";
import "core-js/modules/es6.object.assign";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.function.name";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import ApiService from '@/services/apiService';
import { localizeDate } from '../../../utils/vuex';
import get from 'lodash/get';
import { getFileURL } from '../../../utils/file-uploads';
import isObject from 'lodash/isObject';
import VDeviceMixin from '../../../components/core/dtwin/state/virtualDevice/aggregate/mixin.js';
import cloneDeep from 'lodash/cloneDeep';
import multiSearchMixin from '@/mixins/multiSearchVirtualDevices';
import codemirror from '@/mixins/codemirror';
import merge from 'lodash/merge';
import set from 'lodash/set';
var EDIT_MODE = {
  CREATE: 'CREATE',
  EDIT: 'EDIT',
  READ_ONLY: 'READ_ONLY'
};
export default {
  name: 'VirtualDeviceDriverDetails',
  mixins: [VDeviceMixin, multiSearchMixin, codemirror],
  data: function data() {
    return {
      accounts: [],
      isFetchingAccounts: true,
      accountFetchingFailed: false,
      linkedDevicesTotalCount: 0,
      showCopyPrompt: false,
      useExpertMode: false,
      activeVersion: 'default',
      showHealthSyncPrompt: false,
      driverIsChanged: false,
      healthIsSyncing: false,
      accountId: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['permissions'])), {}, {
    isCopyPasteAction: function isCopyPasteAction() {
      return this.$route.query.source === 'clipboard';
    },
    driverId: function driverId() {
      return this.$route.params.id;
    },
    isVirtualDeviceDriverManager: function isVirtualDeviceDriverManager() {
      return this.permissions['DeviceDriver.manage'];
    },
    editMode: function editMode() {
      if (this.driverId === 'new' || this.isCopyPasteAction) {
        return EDIT_MODE.CREATE;
      }

      if (this.isVirtualDeviceDriverManager) {
        return EDIT_MODE.EDIT;
      }

      return EDIT_MODE.READ_ONLY;
    },
    pageIsReadOnly: function pageIsReadOnly() {
      return this.editMode === EDIT_MODE.READ_ONLY;
    },
    metaInformationTab: function metaInformationTab() {
      var _this = this;

      var technicalSpecFields = ['manufacturerDeviceName', 'model', 'configuration', 'connectivity', 'frequency', 'txPower', 'txDistance', 'powerSupply', 'operatingTemperature', 'security', 'mounting', 'dimensions', 'weight', 'standard', 'battery', 'batteryLife', 'firmware', 'precision', 'installationHeight', 'usage', 'other'];
      var technicalSpecFieldsGroupedInRowsOfTwo = technicalSpecFields.reduce(function (acc, field, index) {
        if (index % 2 === 0) {
          acc.push({
            columns: []
          });
        }

        acc[acc.length - 1].columns.push({
          cols: 6,
          sm: 12,
          md: 6,
          lg: 6,
          field: {
            label: _this.$i18n_t("DeviceDriver.details.tabs.metaInformation.sections.technicalSpecifications.fields.".concat(field)),
            key: "properties.technical_specs.".concat(field)
          }
        });
        return acc;
      }, []);
      return {
        label: this.$i18n_t('DeviceDriver.details.tabs.metaInformation.title'),
        urlHashbang: 'meta-information',
        rows: [// section: title, account, visibility, description
        {
          columns: [{
            cols: 6,
            sm: 12,
            md: 6,
            lg: 6,
            rows: [{
              columns: [{
                cols: 12,
                field: {
                  label: this.$i18n_t('DeviceDriver.details.tabs.metaInformation.sections.main.fields.title'),
                  key: 'title'
                }
              }]
            }, {
              columns: [{
                cols: 12,
                field: {
                  label: this.$i18n_t('DeviceDriver.details.tabs.metaInformation.sections.main.fields.account'),
                  key: 'accountId',
                  readonly: this.editMode !== EDIT_MODE.CREATE,
                  type: 'autocomplete',
                  options: this.accounts.map(function (account) {
                    return {
                      label: account.name,
                      value: account.id
                    };
                  }),
                  isLoading: this.isFetchingAccounts,
                  errorMessages: this.accountFetchingFailed ? [this.$i18n_t('DeviceDriver.details.fetchAccounts.error.field')] : null
                }
              }]
            }, {
              columns: [{
                cols: 12,
                field: {
                  label: this.$i18n_t('DeviceDriver.details.tabs.metaInformation.sections.main.fields.visibility.label'),
                  key: 'visibility',
                  type: 'select',
                  options: [{
                    // account
                    label: this.$i18n_t('DeviceDriver.details.tabs.metaInformation.sections.main.fields.visibility.options.account'),
                    value: 'account'
                  }, {
                    // everyone
                    label: this.$i18n_t('DeviceDriver.details.tabs.metaInformation.sections.main.fields.visibility.options.everyone'),
                    value: 'everyone'
                  }]
                }
              }]
            }]
          }, {
            cols: 6,
            sm: 12,
            md: 6,
            lg: 6,
            field: {
              label: this.$i18n_t('DeviceDriver.details.tabs.metaInformation.sections.main.fields.description'),
              key: 'description',
              type: 'textarea'
            }
          }]
        }, // section: "Device Image & Attachments"
        {
          headline: this.$i18n_t('DeviceDriver.details.tabs.metaInformation.sections.deviceImage.title'),
          subtitle: this.$i18n_t('DeviceDriver.details.tabs.metaInformation.sections.deviceImage.subtitle'),
          columns: [{
            cols: 6,
            sm: 12,
            md: 6,
            lg: 6,
            field: {
              label: this.$i18n_t('DeviceDriver.details.tabs.metaInformation.sections.deviceImage.fields.image'),
              key: 'image'
            },
            slotName: 'image'
          }, {
            cols: 6,
            sm: 12,
            md: 6,
            lg: 6,
            field: {
              label: this.$i18n_t('DeviceDriver.details.tabs.metaInformation.sections.deviceImage.fields.attachments'),
              key: 'properties.attachments'
            },
            slotName: 'attachments'
          }]
        }, // section: "Installation notes & highlights"
        {
          headline: this.$i18n_t('DeviceDriver.details.tabs.metaInformation.sections.installationNotes.title'),
          subtitle: this.$i18n_t('DeviceDriver.details.tabs.metaInformation.sections.installationNotes.subtitle'),
          columns: [{
            cols: 6,
            sm: 12,
            md: 6,
            lg: 6,
            field: {
              label: this.$i18n_t('DeviceDriver.details.tabs.metaInformation.sections.installationNotes.fields.installationNotes'),
              key: 'properties.notes',
              type: 'textarea'
            }
          }, {
            cols: 6,
            sm: 12,
            md: 6,
            lg: 6,
            field: {
              label: this.$i18n_t('DeviceDriver.details.tabs.metaInformation.sections.installationNotes.fields.highlights'),
              key: 'properties.highlights',
              type: 'textarea'
            }
          }]
        }, // section: "Technical specifications"
        {
          headline: this.$i18n_t('DeviceDriver.details.tabs.metaInformation.sections.technicalSpecifications.title'),
          subtitle: this.$i18n_t('DeviceDriver.details.tabs.metaInformation.sections.technicalSpecifications.subtitle'),
          columns: [{
            cols: 12,
            rows: technicalSpecFieldsGroupedInRowsOfTwo
          }]
        }]
      };
    },
    packetParserTab: function packetParserTab() {
      return {
        label: this.$i18n_t('DeviceDriver.details.tabs.packetParser.title'),
        urlHashbang: 'packet-parser',
        rows: [{
          columns: [{
            cols: 12,
            sm: 12,
            md: 12,
            lg: 12,
            slotName: 'packetParserConfigurator'
          }]
        }]
      };
    },
    predefinedDownlinksTab: function predefinedDownlinksTab() {
      var _this2 = this;

      var makeEmptyConfigItem = function makeEmptyConfigItem() {
        return {
          name: '',
          port: 0,
          payload: '',
          encoding: 'base16',
          gatewayId: ''
        };
      };

      var makeDownlinkItemRow = function makeDownlinkItemRow(activeVersionIndex, downlinkItemIndex, currentDownlinkItems) {
        var fieldDefinitions = [{
          cols: 5,
          sm: 12,
          md: 5,
          lg: 5,
          field: {
            key: 'name',
            type: 'string',
            required: true
          }
        }, {
          cols: 2,
          sm: 6,
          md: 2,
          lg: 2,
          field: {
            key: 'port',
            type: 'number',
            required: true
          }
        }, {
          cols: 4,
          sm: 6,
          md: 4,
          lg: 4,
          field: {
            key: 'gatewayId'
          }
        }, {
          cols: 7,
          field: {
            key: 'payload',
            type: 'string',
            required: true
          }
        }, {
          cols: 4,
          field: {
            key: 'encoding',
            type: 'select',
            options: ['base16', 'base64', 'utf8'],
            required: true
          }
        }];
        return {
          columns: [{
            cols: 11,
            rows: [{
              columns: fieldDefinitions.map(function (fieldDefinition) {
                return _objectSpread(_objectSpread({}, fieldDefinition), {}, {
                  field: _objectSpread(_objectSpread({}, fieldDefinition.field), {}, {
                    label: fieldDefinition.field.label || fieldDefinition.field.key && _this2.$i18n_t("DeviceDriver.details.tabs.predefinedDownlinks.fields.".concat(fieldDefinition.field.key)),
                    key: "versions[".concat(activeVersionIndex, "].downlinks[").concat(downlinkItemIndex, "]['").concat(fieldDefinition.field.key, "']"),
                    options: (fieldDefinition.field.options || []).map(function (option) {
                      return {
                        label: _this2.$i18n_t("DeviceDriver.details.tabs.predefinedDownlinks.optionValues.".concat(fieldDefinition.field.key, ".").concat(option)),
                        value: option
                      };
                    })
                  })
                });
              })
            }]
          }, {
            cols: 1,
            rows: [{
              columns: [{
                cols: 12,
                field: {
                  type: 'button',
                  icon: 'fal fa-plus',
                  onClick: function onClick(updateField) {
                    updateField("versions[".concat(activeVersionIndex, "].downlinks"), [].concat(_toConsumableArray(currentDownlinkItems), [makeEmptyConfigItem()]));
                  }
                }
              }]
            }, {
              columns: [{
                cols: 12,
                field: {
                  type: 'button',
                  icon: 'fal fa-trash',
                  onClick: function onClick(updateField) {
                    var newConfigItems = currentDownlinkItems.filter(function (_, index) {
                      return index !== downlinkItemIndex;
                    });
                    updateField("versions[".concat(activeVersionIndex, "].downlinks"), newConfigItems);
                  }
                }
              }]
            }]
          }]
        };
      };

      return function (currentValue) {
        var activeVersionIndex = _this2.getActiveVersionIndex(currentValue);

        var downlinks = cloneDeep(get(currentValue, "versions[".concat(activeVersionIndex, "].downlinks"), []));
        return {
          label: _this2.$i18n_t('DeviceDriver.details.tabs.predefinedDownlinks.title'),
          urlHashbang: 'predefined-downlinks',
          rows: [{
            subtitle: _this2.$i18n_t('DeviceDriver.details.tabs.predefinedDownlinks.description')
          }].concat(_toConsumableArray(downlinks.map(function (item, downlinkIndex) {
            return makeDownlinkItemRow(activeVersionIndex, downlinkIndex, downlinks);
          }).map(function (row, rowIndex) {
            if (rowIndex >= downlinks.length - 1) {
              return [row];
            }

            return [row, {
              isDivider: true
            }];
          }).flat()), [downlinks.length === 0 ? {
            columns: [{
              cols: 12,
              field: {
                type: 'button',
                icon: 'fal fa-plus',
                onClick: function onClick(updateField) {
                  updateField("versions[".concat(activeVersionIndex, "].downlinks"), [].concat(_toConsumableArray(downlinks), [makeEmptyConfigItem()]));
                }
              }
            }]
          } : {}])
        };
      };
    },
    linkedDevicesTab: function linkedDevicesTab() {
      return {
        label: this.$i18n_t('DeviceDriver.details.tabs.linkedDevices.title', {
          count: this.linkedDevicesTotalCount
        }),
        urlHashbang: 'linked-devices',
        eager: true,
        rows: [{
          columns: [{
            cols: 12,
            sm: 12,
            md: 12,
            lg: 12,
            slotName: 'linkedDevices'
          }]
        }]
      };
    },
    tabs: function tabs() {
      return [this.metaInformationTab, this.packetParserTab, this.healthStateTab, this.predefinedDownlinksTab, this.linkedDevicesTab];
    },
    availableDurations: function availableDurations() {
      var _this3 = this;

      var baseTranslation = 'DigitalTwin.DigitalTwin.visualization.timeRanges.count';
      return [15, 30].map(function (min) {
        return {
          value: min * 60,
          label: _this3.$i18n_tc("".concat(baseTranslation, "Min"), min, {
            n: min
          })
        };
      }).concat([1, 3, 6, 12, 24].map(function (hour) {
        return {
          value: hour * 3600,
          label: _this3.$i18n_tc("".concat(baseTranslation, "Hour"), hour, {
            n: hour
          })
        };
      })).concat([2, 7, 14].map(function (day) {
        return {
          value: day * 86400,
          label: _this3.$i18n_tc("".concat(baseTranslation, "Day"), day, {
            n: day
          })
        };
      })).concat([1, 3, 6].map(function (mon) {
        return {
          value: mon * 30 * 86400,
          label: _this3.$i18n_tc("".concat(baseTranslation, "Month"), mon, {
            n: mon
          })
        };
      })).concat([{
        value: 365 * 86400,
        label: this.$i18n_t('DigitalTwin.DigitalTwin.visualization.timeRanges.1Y')
      }]);
    },
    linkedDevicesPredefinedSearch: function linkedDevicesPredefinedSearch() {
      return [{
        param: 'deviceDriver',
        search: {
          value: this.driverId
        }
      }];
    },
    syncHealthToVDPromptButtons: function syncHealthToVDPromptButtons() {
      var buttons = [{
        text: this.$i18n_t('DeviceDriver.details.prompts.syncHealthToVD.buttons.cancel'),
        emit: 'cancel'
      }];

      if (!this.driverIsChanged) {
        buttons.unshift({
          text: this.$i18n_t('DeviceDriver.details.prompts.syncHealthToVD.buttons.sync'),
          emit: 'sync',
          isLoading: this.healthIsSyncing
        });
      }

      return buttons;
    }
  }),
  created: function created() {
    this.fetchAccounts();
    this.getMultiFilterData();
  },
  methods: {
    get: get,
    localizeDate: localizeDate,
    getActiveVersionIndex: function getActiveVersionIndex(driver) {
      var versions = get(driver, 'versions', []);
      return versions.findIndex(function (v) {
        return v.version === 'default';
      });
    },
    fetchDriver: function () {
      var _fetchDriver = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var item, clipboardContent, fetchedItem, versionIndex, healthBaseKey, metrics;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                item = {
                  title: '',
                  description: '',
                  accountId: null,
                  visibility: 'account',
                  properties: {},
                  versions: []
                };

                if (!this.isCopyPasteAction) {
                  _context.next = 20;
                  break;
                }

                _context.prev = 2;
                _context.next = 5;
                return navigator.clipboard.readText();

              case 5:
                clipboardContent = _context.sent;
                item = JSON.parse(clipboardContent);
                delete item.createdAt;
                delete item.updatedAt;
                delete item.id;
                delete item.Tenant;
                _context.next = 18;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](2);
                console.error(_context.t0);
                this.$snack(this.$i18n_t('DeviceDriver.details.copyPasteAction.error.snack.text'), 'error');
                this.$router.push('/virtual-device-drivers');

              case 18:
                _context.next = 25;
                break;

              case 20:
                if (!(this.editMode !== EDIT_MODE.CREATE)) {
                  _context.next = 25;
                  break;
                }

                _context.next = 23;
                return ApiService.virtualDeviceDrivers.fetchOneById(this.driverId);

              case 23:
                fetchedItem = _context.sent;
                item = merge(item, fetchedItem);

              case 25:
                if (!item.versions) {
                  item.versions = [];
                }

                if (!item.versions.some(function (v) {
                  return v.version === 'default';
                })) {
                  item.versions.push({
                    version: 'default'
                  });
                }

                item.description = item.description || '';
                versionIndex = this.getActiveVersionIndex(item);
                healthBaseKey = "versions[".concat(versionIndex, "].healthStateConfig");
                metrics = get(item, "".concat(healthBaseKey, ".health"), []);

                if (metrics.length > 0) {
                  this.useExpertMode = !metrics.some(function (m) {
                    return m.wizard;
                  });
                }

                this.accountId = item.accountId;
                return _context.abrupt("return", item);

              case 34:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 13]]);
      }));

      function fetchDriver() {
        return _fetchDriver.apply(this, arguments);
      }

      return fetchDriver;
    }(),
    saveItem: function () {
      var _saveItem = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(item) {
        var _this4 = this;

        var versionIndex, healthBaseKey, metrics;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // update wizard property on all metrics, just to make sure...
                versionIndex = this.getActiveVersionIndex(item);
                healthBaseKey = "versions[".concat(versionIndex, "].healthStateConfig.health");
                metrics = get(item, "".concat(healthBaseKey), []);
                set(item, healthBaseKey, metrics.map(function (m) {
                  return _objectSpread(_objectSpread({}, m), {}, {
                    wizard: !_this4.useExpertMode
                  });
                }));

                if (!(item.id && !this.isCopyPasteAction)) {
                  _context2.next = 8;
                  break;
                }

                _context2.next = 7;
                return ApiService.virtualDeviceDrivers.updateOne(item.id, item);

              case 7:
                return _context2.abrupt("return", _context2.sent);

              case 8:
                _context2.next = 10;
                return ApiService.virtualDeviceDrivers.createOne(item);

              case 10:
                return _context2.abrupt("return", _context2.sent);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function saveItem(_x) {
        return _saveItem.apply(this, arguments);
      }

      return saveItem;
    }(),
    fetchAccounts: function () {
      var _fetchAccounts = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var accounts;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                this.isFetchingAccounts = true;
                _context3.next = 4;
                return this.$store.dispatch('app/loadAccounts');

              case 4:
                accounts = _context3.sent;
                // filter the root-tenant, because that one does not have a twin to attach the new device to
                this.accounts = accounts.filter(function (t) {
                  return !t.isRootTenant;
                });
                _context3.next = 13;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](0);
                console.error(_context3.t0);
                this.$snack(this.$i18n_t('DeviceDriver.details.fetchAccounts.error.snack.text'), 'error');
                this.accountFetchingFailed = true;

              case 13:
                _context3.prev = 13;
                this.isFetchingAccounts = false;
                return _context3.finish(13);

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 8, 13, 16]]);
      }));

      function fetchAccounts() {
        return _fetchAccounts.apply(this, arguments);
      }

      return fetchAccounts;
    }(),
    headline: function headline(item) {
      if (this.editMode === EDIT_MODE.CREATE) {
        return this.$i18n_t('DeviceDriver.details.header.title.create');
      }

      return item.title || this.$i18n_t('DeviceDriver.details.header.title.fallback');
    },
    subtitle: function subtitle(item) {
      if (this.editMode === EDIT_MODE.CREATE) {
        return this.$i18n_t('DeviceDriver.details.header.subtitle.create');
      }

      return item.account || this.$i18n_t('DeviceDriver.details.header.subtitle.fallback');
    },
    getImageUrl: function getImageUrl(fileId) {
      return getFileURL(fileId, 2);
    },
    getActiveVersion: function getActiveVersion(item) {
      var activeVersionIndex = this.getActiveVersionIndex(item);
      var activeVersion = get(item, 'versions', [])[activeVersionIndex];
      return activeVersion ? activeVersion : {};
    },
    getConfigForParserWrapper: function getConfigForParserWrapper(parser) {
      return parser;
    },
    onSaveParser: function onSaveParser(newParserConfig, slotProps) {
      var _this5 = this;

      var updatedVersion = _objectSpread(_objectSpread({}, newParserConfig), {}, {
        version: this.activeVersion,
        account: undefined
      });

      slotProps.updateFieldByKey(function (updateByKey, originalItem) {
        var versions = get(originalItem, 'versions', []);
        var unchangedVersions = versions.filter(function (v) {
          return v.version !== _this5.activeVersion;
        });
        var newVersions = [].concat(_toConsumableArray(unchangedVersions), [updatedVersion]);
        updateByKey('versions', newVersions);
      });
    },
    deviceDriverParserTester: function deviceDriverParserTester(slotProps) {
      var _this6 = this;

      return /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(payload, meta) {
          var activeVersion;
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  activeVersion = _this6.getActiveVersion(slotProps.item);

                  if (activeVersion) {
                    _context4.next = 3;
                    break;
                  }

                  throw new Error('No default version found');

                case 3:
                  _context4.next = 5;
                  return ApiService.deviceDriverParsePayload(activeVersion.parser, {
                    payload: payload,
                    meta: meta
                  });

                case 5:
                  return _context4.abrupt("return", _context4.sent);

                case 6:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        return function (_x2, _x3) {
          return _ref.apply(this, arguments);
        };
      }();
    },
    healthStateTab: function healthStateTab(item, originalItem) {
      var _this7 = this;

      var versionIndex = this.getActiveVersionIndex(item);
      var healthBaseKey = "versions[".concat(versionIndex, "].healthStateConfig");
      var metrics = get(item, "".concat(healthBaseKey, ".health"), []);
      var healthStateNormalTabRows = this.healthStateNormalTabRows(item, originalItem);
      var healthStateExpertTabRows = this.healthStateExpertTabRows(item, originalItem);
      return {
        label: this.$i18n_t('DeviceDriver.details.tabs.healthState.title'),
        urlHashbang: 'health',
        rows: [{
          columns: [{
            field: {
              label: this.$i18n_t('DeviceDriver.details.tabs.healthState.fields.expertMode'),
              type: 'switch',
              value: this.useExpertMode,
              onInput: function () {
                var _onInput = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(_ref2) {
                  var updateItemByFieldKey, waitForUserConsent, rerenderInput, hasConsent;
                  return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          updateItemByFieldKey = _ref2.updateItemByFieldKey, waitForUserConsent = _ref2.waitForUserConsent, rerenderInput = _ref2.rerenderInput;
                          _context5.next = 3;
                          return waitForUserConsent(_this7.$i18n_t('DeviceDriver.details.tabs.healthState.swapExpertModeDialog.title'), _this7.$i18n_t('DeviceDriver.details.tabs.healthState.swapExpertModeDialog.message'));

                        case 3:
                          hasConsent = _context5.sent;

                          if (hasConsent) {
                            _context5.next = 6;
                            break;
                          }

                          return _context5.abrupt("return");

                        case 6:
                          updateItemByFieldKey("".concat(healthBaseKey, ".health"), metrics.map(function (m) {
                            return _objectSpread(_objectSpread({}, m), {}, {
                              wizard: _this7.useExpertMode
                            });
                          }));
                          _this7.useExpertMode = !_this7.useExpertMode;
                          rerenderInput();

                        case 9:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee5);
                }));

                function onInput(_x4) {
                  return _onInput.apply(this, arguments);
                }

                return onInput;
              }()
            }
          }, {
            class: 'flex-grow-0',
            field: {
              label: this.$i18n_t('DeviceDriver.details.tabs.healthState.fields.applyToAllVD'),
              type: 'button',
              readonly: this.linkedDevicesTotalCount === 0 ? true : false,
              onClick: function onClick() {
                _this7.showHealthSyncPrompt = true;
              }
            }
          }]
        }].concat(_toConsumableArray(this.useExpertMode ? healthStateExpertTabRows : healthStateNormalTabRows))
      };
    },
    syncHealthStates: function () {
      var _syncHealthStates = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                this.healthIsSyncing = true;
                _context6.next = 4;
                return ApiService.createBackgroundRunnerBulkEdit({
                  entities: [],
                  tenantId: this.accountId,
                  title: this.jobTitle,
                  executions: {
                    syncHealthConfigurationFromDeviceDriver: {
                      deviceDriverId: parseInt(this.driverId)
                    }
                  }
                });

              case 4:
                this.$snack(this.$i18n_t('DeviceDriver.details.prompts.syncHealthToVD.snack.success', {
                  count: this.linkedDevicesTotalCount
                }), 'success');
                _context6.next = 11;
                break;

              case 7:
                _context6.prev = 7;
                _context6.t0 = _context6["catch"](0);
                console.error(_context6.t0);
                this.$snack(this.$i18n_t('DeviceDriver.details.prompts.syncHealthToVD.snack.error'), 'error');

              case 11:
                _context6.prev = 11;
                this.healthIsSyncing = false;
                return _context6.finish(11);

              case 14:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 7, 11, 14]]);
      }));

      function syncHealthStates() {
        return _syncHealthStates.apply(this, arguments);
      }

      return syncHealthStates;
    }(),
    getParserVariables: function getParserVariables(driverVersion) {
      var _this8 = this;

      var parserVariables = get(driverVersion, 'parser.config.variables', {});
      var isMultiParser = get(driverVersion, 'parser.type') === 'multi';

      if (isMultiParser) {
        parserVariables = {};
        var parserKeys = Object.keys(get(driverVersion, 'parser.config') || {}).filter(function (k) {
          return k !== '__switch';
        });
        parserKeys.forEach(function (pKey) {
          var parserVariablesOfKey = get(driverVersion, "parser.config.".concat(pKey, ".variables"));

          if (isObject(parserVariablesOfKey)) {
            Object.assign(parserVariables, parserVariablesOfKey);
          }
        });
      }

      var parserVariablesCount = Object.keys(parserVariables).length;

      if (parserVariablesCount > 0) {
        parserVariables['_raw'] = {
          value_type: {
            name: 'json'
          },
          key: '_raw'
        };
      }

      var mappedParserVariables = Object.keys(parserVariables).map(function (key) {
        var mapped = _this8.mapStateToUi(parserVariables[key]);

        return {
          label: mapped.key,
          value: mapped.id
        };
      });
      return mappedParserVariables;
    },
    healthStateNormalTabRows: function healthStateNormalTabRows(item) {
      var _this9 = this;

      var versionIndex = this.getActiveVersionIndex(item);
      var healthBaseKey = "versions[".concat(versionIndex, "].healthStateConfig.health");
      var currentHealthStates = get(item, healthBaseKey, []);

      if (currentHealthStates.length === 0) {
        var emptyState = {
          columns: [{
            class: 'text-center',
            field: {
              type: 'emptystate',
              icon: 'fal fa-sensor-smoke',
              title: this.$i18n_t('DeviceDriver.details.tabs.healthState.emptyState.title'),
              description: this.$i18n_t('DeviceDriver.details.tabs.healthState.emptyState.description'),
              button: this.$i18n_t('DeviceDriver.details.tabs.healthState.emptyState.buttonCreate'),
              onClick: function onClick(updateField) {
                var nextUnusedMetricID = 0;

                while (currentHealthStates.some(function (m) {
                  return m.identifier === "metric_".concat(nextUnusedMetricID);
                })) {
                  nextUnusedMetricID++;
                }

                var emptyState = {
                  type: 'warning',
                  // TODO: how to handle this?
                  jsTransformer: '',
                  wizard: true,
                  operator: 'EQUALS',
                  identifier: "metric_".concat(nextUnusedMetricID),
                  wiredState: '_raw',
                  category: '',
                  description: '',
                  value: ''
                };
                updateField(healthBaseKey, [].concat(_toConsumableArray(currentHealthStates), [emptyState]));
              }
            }
          }]
        };
        return [emptyState];
      }

      var valueField = function valueField(state) {
        if (state.operator === 'VALUE_OLDER_THAN') {
          return {
            key: 'value',
            label: _this9.$i18n_t('DigitalTwin.VirtualDevice.state.health.olderThanDuration'),
            type: 'select',
            options: _this9.availableDurations,
            required: true
          };
        }

        return {
          key: 'value',
          label: _this9.$i18n_t('DigitalTwin.DigitalTwin.states.value'),
          required: true
        };
      };

      var wiredStateField = function wiredStateField(state) {
        if (state.operator === 'VALUE_OLDER_THAN') {
          return {
            key: 'wiredState',
            label: _this9.$i18n_t('DigitalTwin.DigitalTwin.states.dataState'),
            type: 'text',
            readonly: true,
            value: '_raw'
          };
        }

        var activeVersion = _this9.getActiveVersion(item);

        var parserVariables = _this9.getParserVariables(activeVersion);

        return {
          key: 'wiredState',
          label: _this9.$i18n_t('DigitalTwin.DigitalTwin.states.dataState'),
          type: 'select',
          options: parserVariables
        };
      };

      var inputRows = [[{
        field: {
          key: 'type',
          label: this.$i18n_t('Common.type'),
          type: 'select',
          options: [{
            value: 'warning',
            label: this.$i18n_t('DigitalTwin.VirtualDevice.state.health.typeWarning')
          }, {
            value: 'error',
            label: this.$i18n_t('DigitalTwin.VirtualDevice.state.health.typeError')
          }]
        }
      }, {
        field: {
          key: 'category',
          label: this.$i18n_t('DigitalTwin.VirtualDevice.state.health.category.label'),
          type: 'select',
          options: [{
            value: 'battery',
            label: this.$i18n_t('DigitalTwin.VirtualDevice.state.health.category.value.battery')
          }, {
            value: 'connectivity',
            label: this.$i18n_t('DigitalTwin.VirtualDevice.state.health.category.value.connectivity')
          }, {
            value: 'device',
            label: this.$i18n_t('DigitalTwin.VirtualDevice.state.health.category.value.device')
          }]
        }
      }, {
        field: {
          key: 'description',
          label: this.$i18n_t('DigitalTwin.VirtualDevice.state.health.wizardDescriptionField')
        }
      }], [{
        field: wiredStateField
      }, {
        field: {
          type: 'select',
          key: 'operator',
          label: this.$i18n_t('Consumers.Filter.createDialog.operator'),
          options: [{
            label: this.$i18n_t('Consumers.Filter.createDialog.operators.valueOlderThan'),
            value: 'VALUE_OLDER_THAN'
          }, {
            label: this.$i18n_t('Consumers.Filter.createDialog.operators.equals'),
            value: 'EQUALS'
          }, {
            label: this.$i18n_t('Consumers.Filter.createDialog.operators.notEquals'),
            value: 'NOT_EQUALS'
          }, {
            label: this.$i18n_t('Consumers.Filter.createDialog.operators.greaterThan'),
            value: 'GREATER_THAN'
          }, {
            label: this.$i18n_t('Consumers.Filter.createDialog.operators.lessThan'),
            value: 'LESS_THAN'
          }, {
            label: this.$i18n_t('Consumers.Filter.createDialog.operators.contains'),
            value: 'CONTAINS'
          }, {
            label: this.$i18n_t('Consumers.Filter.createDialog.operators.notContains'),
            value: 'NOT_CONTAINS'
          }, {
            label: this.$i18n_t('Consumers.Filter.createDialog.operators.isNull'),
            value: 'IS_NULL'
          }, {
            label: this.$i18n_t('Consumers.Filter.createDialog.operators.isNotNull'),
            value: 'IS_NOT_NULL'
          }]
        }
      }, {
        field: valueField
      }]];
      var healthStateRows = currentHealthStates.map(function (state, stateIndex) {
        return {
          class: 'v-card v-sheet elevation-2 v-card__text',
          columns: [{
            rows: inputRows.map(function (inputRow) {
              var inputColumns = inputRow.map(function (input) {
                var computedField = typeof input.field === 'function' ? input.field(state) : input.field;
                return {
                  cols: input.cols,
                  sm: input.sm,
                  md: input.md,
                  lg: input.lg,
                  field: _objectSpread(_objectSpread({}, computedField), {}, {
                    key: "".concat(healthBaseKey, "[").concat(stateIndex, "].").concat(computedField.key)
                  })
                };
              });
              return {
                columns: inputColumns
              };
            })
          }, {
            class: 'flex-grow-0',
            rows: [{
              columns: [{
                field: {
                  type: 'button',
                  icon: 'fal fa-trash',
                  onClick: function onClick(updateField) {
                    var newHealthStates = currentHealthStates.filter(function (_, index) {
                      return index !== stateIndex;
                    });
                    updateField(healthBaseKey, newHealthStates);
                  }
                }
              }]
            }]
          }]
        };
      });
      var addButtonRow = {
        columns: [{
          class: 'flex-grow-0 pl-0',
          field: {
            key: 'addButton',
            type: 'button',
            icon: 'fal fa-plus',
            onClick: function onClick(updateField) {
              var nextUnusedMetricID = 0;

              while (currentHealthStates.some(function (m) {
                return m.identifier === "metric_".concat(nextUnusedMetricID);
              })) {
                nextUnusedMetricID++;
              }

              var emptyState = {
                type: 'warning',
                // TODO: how to handle this?
                jsTransformer: '',
                wizard: true,
                operator: 'EQUALS',
                identifier: "metric_".concat(nextUnusedMetricID),
                wiredState: '_raw',
                category: '',
                description: '',
                value: ''
              };
              updateField(healthBaseKey, [].concat(_toConsumableArray(currentHealthStates), [emptyState]));
            }
          }
        }]
      };
      var healthStateRowsWithSpacers = [];
      healthStateRows.forEach(function (row, index) {
        healthStateRowsWithSpacers.push({
          subtitle: currentHealthStates[index].identifier
        });
        healthStateRowsWithSpacers.push(row);

        if (index >= healthStateRows.length - 1) {
          return;
        }

        healthStateRowsWithSpacers.push({
          isDivider: true
        });
      });
      return [].concat(healthStateRowsWithSpacers, [addButtonRow]);
    },
    healthStateExpertTabRows: function healthStateExpertTabRows(item) {
      var _this10 = this;

      var versions = get(item, 'versions', []);
      var defaultVersionIndex = versions.findIndex(function (v) {
        return v.version === 'default';
      });
      var parserBaseKey = "versions[".concat(defaultVersionIndex, "].parser");
      var healthBaseKey = "versions[".concat(defaultVersionIndex, "].healthStateConfig");
      var selectedStatesPreview = Object.fromEntries(get(item, "".concat(healthBaseKey, ".stateKeys"), []).map(function (stateKey) {
        return [stateKey, {
          value: 'LAST_VALUE',
          time: 'ISO_TIMESTAMP_LAST_UPDATE'
        }];
      }));
      var currentMetrics = get(item, "".concat(healthBaseKey, ".health"), []);
      var metricsRows = currentMetrics.map(function (metric, metricIndex) {
        return {
          subtitle: metric.identifier,
          columns: [// type
          {
            cols: 12,
            sm: 12,
            md: 3,
            lg: 3,
            field: {
              label: _this10.$i18n_t('Common.type'),
              key: "".concat(healthBaseKey, ".health[").concat(metricIndex, "].type"),
              type: 'select',
              options: [// TODO: add all options
              {
                value: 'warning',
                label: _this10.$i18n_t('DigitalTwin.VirtualDevice.state.health.typeWarning')
              }, {
                value: 'error',
                label: _this10.$i18n_t('DigitalTwin.VirtualDevice.state.health.typeError')
              }]
            }
          }, // category
          {
            cols: 12,
            sm: 12,
            md: 3,
            lg: 3,
            field: {
              label: _this10.$i18n_t('DigitalTwin.VirtualDevice.state.health.category.label'),
              key: "".concat(healthBaseKey, ".health[").concat(metricIndex, "].category"),
              type: 'select',
              options: [// TODO: add all options
              {
                label: _this10.$i18n_t('DigitalTwin.VirtualDevice.state.health.category.value.battery'),
                value: 'battery'
              }, {
                label: _this10.$i18n_t('DigitalTwin.VirtualDevice.state.health.category.value.connectivity'),
                value: 'connectivity'
              }, {
                label: _this10.$i18n_t('DigitalTwin.VirtualDevice.state.health.category.value.device'),
                value: 'device'
              }]
            }
          }, // identifier
          {
            cols: 12,
            sm: 12,
            md: 5,
            lg: 5,
            isSpacer: true
          }, // trash button
          {
            cols: 12,
            sm: 12,
            md: 1,
            lg: 1,
            field: {
              type: 'button',
              icon: 'fal fa-trash',
              onClick: function onClick(updateField) {
                updateField("".concat(healthBaseKey, ".health"), currentMetrics.filter(function (_, index) {
                  return index !== metricIndex;
                }));
              }
            }
          }, {
            cols: 12,
            sm: 12,
            md: 12,
            lg: 12,
            slotName: 'healthStateExpertModeMetricCodeEditor',
            field: {
              key: "".concat(healthBaseKey, ".health[").concat(metricIndex, "].jsTransformer")
            }
          }]
        };
      });
      return [// select states
      {
        subtitle: this.$i18n_t('DigitalTwin.VirtualDevice.state.health.metricDescription'),
        columns: [{
          cols: 12,
          sm: 12,
          md: 12,
          lg: 12,
          field: {
            label: this.$i18n_t('DeviceDriver.details.tabs.healthState.fields.stateKeys'),
            key: "".concat(healthBaseKey, ".stateKeys"),
            type: 'autocomplete',
            multiple: true,
            options: Object.entries(get(item, "".concat(parserBaseKey, ".config.variables"), {})).map(function (_ref3) {
              var _ref4 = _slicedToArray(_ref3, 2),
                  key = _ref4[0],
                  value = _ref4[1];

              return {
                label: get(value, 'name', key),
                value: key
              };
            })
          }
        }]
      }, // quick tutorial / example
      {
        isExpansionPanel: true,
        headline: this.$i18n_t('NiotaClassic.DeviceTypes.form.parser.quickReferenceHeader'),
        subtitle: this.$i18n_t('DigitalTwin.VirtualDevice.state.health.metricExample'),
        columns: [{
          cols: 12,
          sm: 12,
          md: 12,
          lg: 12,
          field: {
            type: 'code',
            fullWidth: true,
            content: "function (params) {\n  // get battery voltage from params\n  const batteryVoltage = params['battery_voltage'].value;\n\n  // battery voltage is below 2.5V\n  if (batteryVoltage < 2.5) {\n    return \"Battery almost empty\";\n  }\n\n  // get current time/date\n  const now = new Date();\n\n  // 24hrs * 3600s/day * 1000ms/s\n  const 24hoursInMilliseconds = 24 * 3600 * 1000;\n\n  // get the last heartbeat time from params\n  const lastHeartbeatTime = new Date(params['heartbeat'].time);\n\n  // has not sent a heartbeat within 24 hours\n  if ((now - lastHeartbeatTime) > 24hoursInMilliseconds) {\n    return \"Device seems offline\";\n  }\n\n  return null;\n}"
          }
        }]
      }, // params preview
      {
        columns: [{
          cols: 12,
          sm: 12,
          md: 12,
          lg: 12,
          field: {
            type: 'code',
            fullWidth: true,
            content: "params = ".concat(JSON.stringify(selectedStatesPreview, null, 4), ";")
          }
        }]
      }].concat(_toConsumableArray(metricsRows.map(function (row, rowIndex) {
        return metricsRows.length > 1 && rowIndex !== metricsRows.length - 1 ? [row, {
          isDivider: true
        }] : [row];
      }).flat()), [// add another metric button
      {
        columns: [{
          cols: 12,
          sm: 12,
          md: 12,
          lg: 8,
          field: {
            type: 'button',
            icon: 'fal fa-plus',
            onClick: function onClick(updateField) {
              var nextUnusedMetricID = 0;

              while (currentMetrics.some(function (m) {
                return m.identifier === "metric_".concat(nextUnusedMetricID);
              })) {
                nextUnusedMetricID++;
              }

              updateField("".concat(healthBaseKey, ".health"), [].concat(_toConsumableArray(currentMetrics), [{
                identifier: "metric_".concat(nextUnusedMetricID),
                wizard: false
              }]));
            }
          }
        }]
      }]);
    },
    setLinkedDevicesTotalCountItems: function setLinkedDevicesTotalCountItems(payload) {
      this.linkedDevicesTotalCount = payload.totalCount;
    },
    headerButtons: function headerButtons(currentItem) {
      var _this11 = this;

      var isLoading = false;
      return [{
        icon: 'fa fa-copy',
        title: this.$i18n_t('Common.copy'),
        isLoading: isLoading,
        onClick: function () {
          var _onClick = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
            return regeneratorRuntime.wrap(function _callee7$(_context7) {
              while (1) {
                switch (_context7.prev = _context7.next) {
                  case 0:
                    isLoading = true;

                    try {
                      navigator.clipboard.writeText(JSON.stringify(currentItem));
                    } finally {
                      isLoading = false;
                    }

                    _this11.showCopyPrompt = true;

                  case 3:
                  case "end":
                    return _context7.stop();
                }
              }
            }, _callee7);
          }));

          function onClick() {
            return _onClick.apply(this, arguments);
          }

          return onClick;
        }()
      }];
    }
  }
};